export const isStaging = import.meta.env.VITE_APP_ENV === 'staging'
export const isProduction = import.meta.env.VITE_APP_ENV === 'production'
export const isDevelopment = import.meta.env.VITE_APP_ENV === 'development'
export const notProductionEnvironment = isDevelopment || isStaging
